export function getAPIBaseUrl() {
  return process.env.API_BASE_URL
}

export function getCDNBaseUrl() {
  return process.env.CDN_BASE_URL
}
